export const SCOPE_TYPE_READ = 'read';
export const SCOPE_TYPE_WRITE = 'write';

export type SCOPE_TYPE = typeof SCOPE_TYPE_READ | typeof SCOPE_TYPE_WRITE;

export const READ_HEALTHDATA_SCOPE = 'read.healthdata';
export const WRITE_HEALTHDATA_SCOPE = 'write.healthdata';
export const HEALTH_DATA_SCOPES = [READ_HEALTHDATA_SCOPE, WRITE_HEALTHDATA_SCOPE];
